// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';


class SessionObjective extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      session_obj: '',
      
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }


  componentDidMount() {}

  handleChange(event) {
    this.setState({session_obj: event.target.value});
  }

  postSessionObjective(data, props) {
    const url = `${getLocationOrigin()}/fixture_session/${this.state.id}/set_session_objective/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'objective': data
                      });

    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.Message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.Message);
      });
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    this.postSessionObjective(this.state.session_obj, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Session Objective</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Session Objective
              </div>
              <div className="col-md-6 input-group">
                <textarea rows="4" cols="33" id="session_obj" name="session_obj" placeholder="Session Objective" onChange={this.handleChange}>
                {this.state.session_obj}
                </textarea>
              </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default SessionObjective;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/sessionObjective/index.js